import React, {useState, useEffect} from 'react';
import {useTranslation} from "react-i18next";
import parse from "html-react-parser";
import {useFetching} from "../../../hooks/useFetching";
import {API_INDEX_TECHNOLOGY} from "../../../utils/consts";
import cookie from "js-cookie";
import ApiIndexTechnology from "../../../services/Index/Technology";

import ios from '../../../img/platforms/ios.png'
import android from '../../../img/platforms/android.svg'
import macOS from '../../../img/platforms/macOS.png'
import windows from '../../../img/platforms/windows.png'
import linux from '../../../img/platforms/linux.png'
import {observer} from "mobx-react-lite";

import OwlCarousel from 'react-owl-carousel2';
import 'react-owl-carousel2/lib/styles.css';
import 'react-owl-carousel2/src/owl.theme.default.css';

const getPlatform = () => {
    return (
        <>
            <div className="box ios">
                <div className="img">
                    <img src={ios} alt="ios" />
                </div>
                <span>iPhone OS</span>
            </div>
            <div className="box">
                <div className="img">
                    <img src={android} alt="android" />
                </div>
                <span>Android</span>
            </div>
            <div className="box">
                <div className="img">
                    <img src={macOS} alt="macOS" />
                </div>
                <span>macOS Apple</span>
            </div>
            <div className="box">
                <div className="img">
                    <img src={windows} alt="windows" />
                </div>
                <span>Windows</span>
            </div>
            <div className="box linux">
                <div className="img">
                    <img src={linux} alt="linux" />
                </div>
                <span>Linux</span>
            </div>
        </>
    )
};

const Technology = () => {
    const {t} = useTranslation();
    const curr_lang = cookie.get('i18next');
    const [text, setText] = useState('');
    // const [text, setText] = useState('<p>Мы используем самые передовые технологии, которые позволяют запускать игры Champion Studio на любых операционных системах и устройствах.</p>');

    const [FunctionApiIndexPlatforms] = useFetching(async () => {
        const response = await ApiIndexTechnology.getApiIndexTechnology(API_INDEX_TECHNOLOGY);
        setText(response.data.text);
    });

    useEffect(() => {
        FunctionApiIndexPlatforms();
    }, [curr_lang]); // eslint-disable-line react-hooks/exhaustive-deps

    const options = {
        items: 4,
        margin: 32,
        loop: true,
        nav: false,
        dots: false,
        autoWidth: true,
        center: true,
        responsive: {
            0: {
                items: 1,
                margin: 54,
            },
            768: {
                items: 4,
                margin: 85,
            },
            1024: {
                items: 5,
                margin: 92,
            },
        }
    };
    return (
        <div className="platforms">
            <div className="row">
                <div className="title_block">
                    <h1>{t('Technology')}</h1>
                    {text && parse(text)}
                </div>
                {document.body.clientWidth >= 1024
                    ? <div className="boxing">
                        {getPlatform()}
                    </div>
                    : <OwlCarousel options={options} touch-action="pan-y" className="boxing owl-carousel owl-theme" >
                        {getPlatform()}
                    </OwlCarousel>}
            </div>
        </div>
    );
};

export default observer(Technology);